<div class="resource-tools-column" fxLayout="column">
    <div
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="0px"
        fxLayoutAlign.lt-md="end center"
        fxLayoutGap.lt-lg="10px"
        class="res-action-btn"
    >
        <!-- <p fxHide.lt-md="true" i18n class="mt-1 third-column-title">Save options</p> -->
        <button
            *ngIf="resource?.id"
            class="grey"
            matTooltip="Add to favorite"
            i18n-matTooltip="@@addToFavorite"
            (click)="favoriteResource(resource)"
            mat-icon-button
            fxFlex="0 0 auto"
        >
            <mat-icon>{{ resource.favorite ? 'star' : 'star_border' }}</mat-icon>
        </button>
        <!-- <button
            type="button"
            matTooltip="Specify which learners and groups who will have access."
            i18n-matTooltip
            class="specify-btn"
            mat-icon-button
            *ngIf="(resource && resource?.id) || (resourceBuilder?.getResource() | async)"
            (click)="specify()"
        >
            <mat-icon>manage_accounts</mat-icon>
            <div class="have-attached {{ accessLevel }}"></div>
        </button> -->
        <button
            type="button"
            matTooltip="Access controls"
            i18n-matTooltip
            class="specify-btn"
            mat-icon-button
            (click)="authorizeUsers()"
        >
            <mat-icon>manage_accounts</mat-icon>
        </button>
        <button
            *ngIf="!!resource?.id && user.privileges.public != 'allowed'"
            type="button"
            [matTooltip]="getPubToolTip() ?? ''"
            class="specify-btn"
            mat-icon-button
            [ngClass]="{
                'disabled-btn-action':
                    user.privileges.public == 'not_allowed' ||
                    (user.privileges.public == 'approval_required' && !resourceForm.value.publish),
                'orange-color': resource?.publication?.approval_status == 'pending',
                'green-color': resource?.publication?.approval_status == 'approved',
                'red-color': resource?.publication?.approval_status == 'rejected'
            }"
            (click)="makeResourcePublic()"
        >
            <mat-icon>public</mat-icon>
        </button>
        <button
            *ngIf="user.privileges.publish != 'allowed'"
            type="button"
            [matTooltip]="getPublishToolTip() ?? ''"
            class="specify-btn"
            mat-icon-button
            [ngClass]="{
                'disabled-btn-action': user.privileges.publish == 'not_allowed',
                'orange-color': resource?.publishment?.approval_status == 'pending',
                'green-color': resource?.publishment?.approval_status == 'approved',
                'red-color': resource?.publishment?.approval_status == 'rejected'
            }"
            (click)="publishResource()"
        >
            <mat-icon>published_with_changes</mat-icon>
        </button>
        <button
            mat-icon-button
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="otherToolsMenu"
            #otherToolsMenuTrigger="matMenuTrigger"
            i18n-matTooltip="@@otherTools"
            matTooltip="Other tools"
            data-testid="resource-manager-other-tools"
        >
            <mat-icon class="kd-icon-24">spoke</mat-icon>
        </button>

        <ng-container *ngIf="!!resource?.id && ResourceTypes.canCreateQuizFromResource(resource?.type_id)">
            <button
                matTooltip="Create a test with AI"
                i18n-matTooltip
                mat-icon-button
                class="create-quiz-btn"
                (click)="createQuiz()"
            >
                <mat-icon
                    fxFlex="0 0 auto"
                    fontSet="klickdata"
                    fontIcon="kd-icon-test"
                    class="course-plan-icon side-nave-icon no-shadow"
                ></mat-icon>
            </button>
        </ng-container>
        <button
            *ngIf="resKeysValidaty"
            matTooltip="Check what you can improve before save."
            i18n-matTooltip
            type="button"
            mat-icon-button
            [ngStyle]="{ color: (resKeysValidaty | resourceProgress)?.color }"
            (click)="checkEfficiency(typeId)"
        >
            <mat-icon>task_alt</mat-icon>
        </button>
    </div>

    <ng-container [ngTemplateOutlet]="actionBtn" [ngTemplateOutletContext]="{ resource: resource }"></ng-container>
    <ng-container *ngIf="currentResourceEditors$ | async; let currentResourceEditors">
        <ng-container *ngIf="!!currentResourceEditors.length">
            <ng-container *ngIf="!onlyMeEditingThisResource(currentResourceEditors)">
                <div class="active-editor-wrapper" fxLayout="row" fxLayoutAlign="start center">
                    <div
                        class="flashing-indicator"
                        matTooltip="You are editing this resource with other editors"
                        i18n-matTooltip="@@youAreEditingThisResourceWithOtherEditors"
                    ></div>
                    <div class="other-editors-count" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <span i18n="@@nowEditing">Now Editing </span>
                    </div>

                    <div class="editor-list" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <div
                            class="editor-item"
                            [ngClass]="{ 'main-editor-item': editor.main_editor }"
                            *ngFor="let editor of currentResourceEditors"
                        >
                            <mat-icon *ngIf="editor.idle_editor">person_off</mat-icon>
                            <app-image-view
                                [matTooltip]="editorPresenceTooltip(editor)"
                                [ngStyle]="{ minWidth: '35px' }"
                                [isCircularImg]="true"
                                [ignoreThumbnail]="true"
                                [media_id]="editor.media"
                                paddingBottom="35px"
                            ></app-image-view>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
    <div
        *ngIf="
            user.privileges.publish == 'allowed' ||
            (user.privileges.publish == 'approval_required' && resource?.publishment?.approval_status == 'approved')
        "
        fxFlex="100"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <mat-checkbox
            #publishCheckbox
            formControlName="publish"
            [disabled]="!(resourceHasItemsSubject | async) && !resourceForm.value.publish"
            color="primary"
            class="draft-checkbox"
            data-testid="resource-manager-publish"
        >
            <div class="publish-label-full" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon class="option">published_with_changes</mat-icon>
                <span fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span i18n>Publish the</span>
                    <span>{{ ResourceTypes.label(typeId, { capitalize: false }) }}</span>
                    <span i18n>in academy</span>
                </span>
            </div>
            <div class="publish-label-cut" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon class="option">published_with_changes</mat-icon>
                <span fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span i18n>Publish in academy</span>
                </span>
            </div>
        </mat-checkbox>
    </div>

    <mat-checkbox
        *ngIf="
            !!resource?.id &&
            resourceForm.value.publish &&
            (user.privileges.publish == 'allowed' ||
                (user.privileges.publish == 'approval_required' &&
                    resource?.publishment?.approval_status == 'approved'))
        "
        formControlName="public"
        color="primary"
        class="draft-checkbox"
    >
        <div
            class="publish-label-full"
            [ngClass]="{ 'disabled-control': resourceForm.get('public')?.disabled }"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
        >
            <mat-icon class="option">public</mat-icon>
            <span fxLayoutAlign="start center" fxLayoutGap="5px">
                <span i18n>Make</span>
                <span>{{ ResourceTypes.label(typeId, { capitalize: false }) }}</span
                ><span i18n>public in KLMS</span>
            </span>
        </div>
        <div
            class="publish-label-cut"
            [ngClass]="{ 'disabled-control': resourceForm.get('public')?.disabled }"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
        >
            <mat-icon class="option">public</mat-icon>
            <span fxLayoutAlign="start center" fxLayoutGap="5px">
                <span i18n>Make public</span>
            </span>
        </div>
    </mat-checkbox>

    <div class="lang-select-profile mt-1">
        <span i18n="@@displayLanguage">Display Language</span>
        <app-language-selector
            formControlName="language_id"
            appLiveEditorField
            [showLabel]="true"
            [disableRipple]="true"
            (afterInit)="resetForm()"
        ></app-language-selector>
    </div>
    <app-tag-chip-select
        class="mt-1"
        placeholder="Add Tag"
        i18n-placeholder
        [sortedAlph]="true"
        [language_id]="resourceForm.value.language_id"
        [tags]="$any(resource?.tags)"
        (onTagClick)="showTagResources($event)"
        formControlName="tag_ids"
        appLiveEditorField
    ></app-tag-chip-select>
    <app-category-chip-select
        fxFlex="0 1 100%"
        [resource_id]="resource?.id ?? 0"
        [language_id]="resourceForm.get('language_id')?.value"
        formControlName="category_ids"
        appLiveEditorField
        [type_id]="typeId"
        (onCatClick)="showCatgeoryResources($event)"
    ></app-category-chip-select>
    <!-- <app-practices-category-chip-select
        fxFlex="0 1 100%"
        [resource_id]="resource?.id"
        [language_id]="resourceForm.get('language_id').value"
        formControlName="category_ids"
        [type_id]="typeId"
        [practiceResourceTypes]="[ResourceTypes.TEST, ResourceTypes.MATERIAL]"
        (onCatClick)="showCatgeoryResources($event)"
    ></app-practices-category-chip-select> -->

    <!-- <div fxHide class="price" fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 100%">
        <span i18n>Price</span>
        <div
            class="wrapper"
            fxLayoutAlign="space-between center"
            fxLayout.lt-md="column"
            fxLayoutGap="10px"
            fxFlex="0 1 100%"
        >
            <mat-form-field appearance="fill" fxFlex="0 0 60%" fxLayout.lt-md="0 0 90%">
                <input matInput type="number" placeholder="Set price" i18n-placeholder formControlName="price" />
            </mat-form-field>
            <mat-select
                class="select-curr"
                fxFlex="0 0 40%"
                fxLayout.lt-md="0 0 90%"
                placeholder="Place choose currency"
                i18n-placeholder
                formControlName="currency"
            >
                <mat-option *ngFor="let currency of currencies" [value]="currency.code">
                    {{ currency.sign }} {{ currency.label }}
                </mat-option>
            </mat-select>
        </div>
    </div> -->
    <ng-container formGroupName="staff">
        <!-- <div fxHide fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 100%" class="manager-wrapper">
            <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
                <div class="manager-label">
                    <span i18n>Publisher</span>
                    <mat-icon class="icon-explain" matTooltip="The academy which publish this resource." i18n-matTooltip
                        >help_outline</mat-icon
                    >
                </div>
                <app-resource-educator-handler
                    class="publisher-edu-handler"
                    [resource]="resource"
                    [maxNumberOfEducatore]="1"
                    formControlName="publisher"
                    searchPlaceholder="Search existing publishers"
                    [setPredefinedEducator]="!resourceForm.value.staff?.publisher"
                    i18n-searchPlaceholder
                    removeBtn="autorenew"
                    [educatorRole]="ResourceStaffRoles.PUBLISHER"
                    i18n-addingLabel
                    addingLabel="Add a new publisher"
                    educatorLabel="Publisher"
                    i18n-educatorLabel
                ></app-resource-educator-handler>
            </div>
        </div> -->
        <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 100%" class="manager-wrapper mt-1">
            <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
                <ng-container [ngTemplateOutlet]="managerLabel"></ng-container>
                <app-resource-manager-author-handler
                    [authUser]="user"
                    [maxNumberOfEducatore]="10"
                    [resource]="resource"
                    [searchPlaceholder]="getLocalizedLabel(true)"
                    i18n-searchPlaceholder
                    [addingLabel]="getLocalizedLabel(false)"
                    i18n-addingLabel
                    [mainEducatorTooltip]="getMainEduTooltip()"
                    [setDefault]="true"
                    [addedSearchFilters]="[{ property: 'customer', items: [user.customer_id] }]"
                    class="w-100 res-third-column-edu-wrapper"
                    formControlName="manager"
                    educatorLabel="Author"
                    i18n-educatorLabel
                ></app-resource-manager-author-handler>
            </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="start start" fxFlex="0 1 100%" class="manager-wrapper mt-1">
            <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
                <div class="manager-label w-100" fxLayout="row" fxLayoutAlign="start center">
                    <span i18n>Editors</span>
                    <mat-icon
                        class="icon-explain"
                        matTooltip="Who is authorized to edit/modify this resource"
                        i18n-matTooltip
                        >help_outline</mat-icon
                    >
                    <mat-icon
                        class="editor-icon"
                        matTooltip="Specify who is authorized to edit/modify this resource"
                        i18n-matTooltip
                        (click)="specifyEditors()"
                        >rule</mat-icon
                    >
                </div>
                <div *ngIf="!!resource?.editors?.length" class="w-100" fxLayout="column" fxLayoutAlign="start start">
                    <ng-container *ngFor="let editor of resource.editors; let i = index">
                        <div *ngIf="i < 2" class="edu-row-wrapper">
                            <mat-checkbox
                                matTooltip="Select editors who appears in the information page"
                                i18n-matTooltip
                                color="primary"
                                [checked]="editor.showsOnInfoPage"
                                (change)="toggleEditorInfoVisibility(editor, $event.checked)"
                            ></mat-checkbox>
                            <app-image-view
                                [ngStyle]="{ minWidth: '40px' }"
                                [isCircularImg]="true"
                                [media_id]="editor.media"
                                paddingBottom="40px"
                            >
                            </app-image-view>
                            <div class="inst-name">{{ editor.name }}</div>
                        </div>
                    </ng-container>

                    <span class="more-editors" (click)="showMoreEditors()" *ngIf="resource.editors.length > 2" i18n
                        >+{{ resource.editors.length - 2 }} more</span
                    >
                </div>
            </div>
        </div>
    </ng-container>
    <div class="tools-lower-actions-btns" fxLayout="column" fxLayoutAlign="space-between start">
        <div class="infor-res-wrap" *ngIf="resource && resource.id" fxLayout="column" fxLayoutAlign="start start">
            <div class="info-res" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <div fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>edit</mat-icon>
                    <span i18n>Created:</span>
                </div>
                <span class="inf">{{ resource.created_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span>
            </div>
            <div
                *ngIf="resource.published"
                class="info-res"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="5px"
            >
                <div fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>published_with_changes</mat-icon>
                    <span i18n>Published:</span>
                </div>
                <span class="inf">{{ resource.published | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span>
            </div>
            <div class="info-res" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <div fxLayoutAlign="start center" fxLayoutGap="5px">
                    <mat-icon>update</mat-icon>
                    <span i18n>Updated:</span>
                </div>
                <span class="inf">{{ resource.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span>
            </div>
        </div>
        <mat-checkbox #nonDuplicableCheckbox formControlName="duplicable" color="primary" class="duplicate-checkbox">
            <div class="publish-label-full" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon class="option">content_copy</mat-icon>
                <span fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span class="duplicate-checkbox-label" i18n>Can be duplicated</span>
                </span>
            </div>
        </mat-checkbox>
        <ng-container *ngIf="resource?.related_resources?.length">
            <ng-container *ngFor="let relatedResource of resource.related_resources; let index = index">
                <app-resource-title-with-icon
                    (click)="view(relatedResource.id)"
                    *ngIf="index < 3 && relatedResource.id"
                    [displayLabel]="true"
                    [resource]="relatedResource"
                ></app-resource-title-with-icon>
            </ng-container>
            <button
                mat-button
                *ngIf="resource.related_resources?.length > 3"
                class="related-res-btn"
                (click)="viewRelatedResources(resource.related_resources)"
            >
                <span>More related resource</span>
            </button>
        </ng-container>
    </div>
</div>
<ng-template #actionBtn let-resource="resource">
    <ng-container *ngIf="loading">
        <button mat-raised-button type="button" class="save-btn draft">
            <div fxLayout="row" fxLayoutAlign="center center" class="spinner-container loader-res">
                <app-kd-logo-loading size="small"></app-kd-logo-loading>
            </div>
        </button>
    </ng-container>
    <ng-container *ngIf="!loading">
        <button
            [ngClass]="{
                draft: !resourceForm.value.publish,
                'is-btn-disabled': isSaveDisabled,
                'disabled-btn': resSubmitDisabledStatus$ | async
            }"
            (click)="onSubmit()"
            [disabled]="isSaveDisabled"
            mat-raised-button
            [disableRipple]="!resourceForm.value.title"
            class="save-btn"
            data-testid="resource-manager-save"
        >
            <mat-icon>save</mat-icon>
            <div fxLayoutAlign="start start" fxLayoutGap="5px">
                <span i18n>Save</span>
                <span>{{ ResourceTypes.label(typeId, { capitalize: false }) }}</span>
                <span *ngIf="!resourceForm.value.publish" i18n>as private</span>
            </div>
        </button>
    </ng-container>
</ng-template>
<ng-template #managerLabel>
    <div class="manager-label" *ngIf="typeId !== ResourceTypes.EVENT">
        <span i18n>Author</span>
        <mat-icon
            class="icon-explain"
            matTooltip="Authors are the main teachers, You can justify the main author."
            i18n-matTooltip
            >help_outline</mat-icon
        >
    </div>
    <div class="manager-label" *ngIf="typeId === ResourceTypes.EVENT">
        <span i18n>Tutor</span>
        <mat-icon
            class="icon-explain"
            matTooltip="Tutors are the main teachers. You can justify the main tutor."
            i18n-matTooltip
            >help_outline</mat-icon
        >
    </div>
</ng-template>
<ng-template #resourceEditors>
    <ng-container *ngIf="resource">
        <div class="editors-slide-wrapper" *ngFor="let editor of resource.editors">
            <mat-checkbox
                matTooltip="Select editors who appears in the information page"
                i18n-matTooltip
                color="primary"
                [checked]="editor.showsOnInfoPage"
                (change)="toggleEditorInfoVisibility(editor, $event.checked)"
            ></mat-checkbox>
            <app-image-view
                [ngStyle]="{ minWidth: '40px' }"
                [isCircularImg]="true"
                [media_id]="editor.media"
                paddingBottom="40px"
            >
            </app-image-view>
            <div class="inst-name">{{ editor.name }}</div>
        </div>
    </ng-container>
</ng-template>
<ng-template #scormPackageInfo let-scorm="scorm">
    <div class="scorm-info" fxLayout="column" fxLayoutGap="6px">
        <div *ngIf="scorm?.title" fxLayout="row" fxLayoutGap="6px" fxLayoutAlign="start center">
            <span><strong i18n>Title:</strong> {{ scorm?.title ?? '' }}</span>
        </div>

        <div *ngIf="scorm?.origin_file" fxLayout="row" fxLayoutGap="6px" fxLayoutAlign="start center">
            <span><strong i18n>File name:</strong> {{ scorm?.origin_file ?? '' }}</span>
        </div>

        <div *ngIf="scorm?.version" fxLayout="row" fxLayoutGap="6px" fxLayoutAlign="start center">
            <span><strong i18n>Version:</strong> {{ scorm?.version ?? '' }}</span>
        </div>

        <div *ngIf="scorm?.created_at" fxLayout="row" fxLayoutGap="6px" fxLayoutAlign="start center">
            <span><strong i18n>Uploaded:</strong> {{ scorm?.created_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span>
        </div>

        <div fxLayout="row" fxLayoutGap="6px" fxLayoutAlign="start center" *ngIf="scorm?.metadata?.package_size">
            <span><strong i18n>Size:</strong> {{ scorm?.metadata?.package_size | number }} KB</span>
        </div>
    </div>
</ng-template>
<mat-menu
    #otherToolsMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="other-tools-menu-backdrop"
>
    <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
        <button type="button" class="specify-btn" mat-button (click)="list()">
            <mat-icon>list</mat-icon>
            <span i18n>List</span>
        </button>
        <button
            *ngIf="resource && resource.downloads"
            class="grey"
            type="button"
            matTooltip="Download"
            i18n-matTooltip="@@download"
            (click)="download(resource)"
            mat-button
        >
            <mat-icon>save_alt</mat-icon>
            <span i18n>Download</span>
        </button>
        <button
            *ngIf="resourceForm.value.id || resource?.id"
            matTooltip="View how it looks for usrs"
            i18n-matTooltip
            type="button"
            mat-button
            (click)="view(resourceForm.value.id ?? resource?.id)"
        >
            <mat-icon>visibility</mat-icon>
            <span i18n>View</span>
        </button>
        <button
            matTooltip="Play"
            mat-button
            type="button"
            (click)="takeResource(resource)"
            *ngIf="resource && resource.id && typeId != ResourceTypes.EVENT"
        >
            <mat-icon>play_circle</mat-icon>
            <span i18n>Play</span>
        </button>
        <button
            matTooltip="Add note to this cource"
            mat-button
            type="button"
            (click)="addResNote(resource)"
            i18n-matTooltip="@@AddNoteToThisCource"
            *ngIf="resource && typeId === ResourceTypes.GeneralCoursePlan"
        >
            <mat-icon class="material-icons-outlined">note_alt</mat-icon>
            <span i18n>Add note</span>
        </button>
        <button
            matTooltip="View SCORM package info"
            mat-button
            type="button"
            (click)="viewScormPackageInfo(resource)"
            i18n-matTooltip="@@ViewScormPackageInfo"
            *ngIf="resource?.id && typeId === ResourceTypes.SCORM"
        >
            <mat-icon>business_center</mat-icon>
            <span i18n>View package</span>
        </button>
        <button
            matTooltip="View log"
            mat-button
            type="button"
            (click)="viewResLog(resource)"
            *ngIf="resource && resource.id"
        >
            <mat-icon>touch_app</mat-icon>
            <span i18n>Log</span>
        </button>

        <button
            [matTooltip]="'Delete ' + ResourceTypes.label(typeId, { capitalize: false })"
            i18n-matTooltip
            mat-button
            type="button"
            (click)="delete(resource)"
            *ngIf="resource?.id && !resource?.deleted_at"
            data-testid="resource-manager-delete"
        >
            <mat-icon>delete</mat-icon>
            <span i18n>Delete</span>
        </button>
        <button
            [matTooltip]="'Restore ' + ResourceTypes.label(typeId, { capitalize: false })"
            i18n-matTooltip
            mat-button
            type="button"
            (click)="restoreResource(resource)"
            *ngIf="resource?.id && resource?.deleted_at"
        >
            <mat-icon>restore_from_trash</mat-icon>
            <span i18n>Restore</span>
        </button>
    </div>
</mat-menu>
